var SW = SW || {};

(function ($) {
  var pixelRatio = !!window.devicePixelRatio ? window.devicePixelRatio : 1;
  var $window = $(window),
    body = $("body"),
    deviceAgent = navigator.userAgent.toLowerCase(),
    isMobileAlt = deviceAgent.match(/(iphone|ipod|ipad|android|iemobile)/),
    imageZoomThreshold = 20;
  var loading = false;
  var infinite_loaded_count = 0;
  SW.header = {
    init: function () {
      $(".search-area a.search-icon").click(function (e) {
        $(".top-links-icon").parent().children("ul.links").removeClass("show");
        if ($("#search_mini_form").is(".show")) {
          $("#search_mini_form").removeClass("show");
        } else {
          $("#search_mini_form").addClass("show");
        }
        e.stopPropagation();
      });
      $(".top-links-icon").click(function (e) {
        $(".search-area a.search-icon")
          .parent()
          .children("#search_mini_form")
          .removeClass("show");
        if ($(this).parent().children("ul.links").hasClass("show")) {
          $(this).parent().children("ul.links").removeClass("show");
        } else $(this).parent().children("ul.links").addClass("show");
        e.stopPropagation();
      });
      $(".search-area a.search-icon")
        .parent()
        .click(function (e) {
          e.stopPropagation();
        });
      $(".mini-cart").hover(
        function () {
          $(this).children().children(".cart-wrapper").fadeIn(200);
        },
        function () {
          $(this).children().children(".cart-wrapper").fadeOut(200);
        }
      );
      $("html,body").click(function () {
        $(".top-links-icon").parent().children("ul.links").removeClass("show");
        $(".search-area a.search-icon")
          .parent()
          .children("#search_mini_form")
          .removeClass("show");
      });
      $(".menu-icon, .mobile-nav-overlay").click(function (event) {
        if (
          !$("body").hasClass("md-mobile-menu") &&
          ($(".header-container").hasClass("type11") ||
            $(".header-container").hasClass("type13") ||
            $(".header-container").hasClass("type7"))
        )
          $("body").addClass("md-mobile-menu");
        if (!$("body").hasClass("mobile-nav-shown")) {
          $("body").addClass("mobile-nav-shown", function () {
            setTimeout(function () {
              $(document).one("click", function (e) {
                var target = e.target;
                if (
                  !$(target).is(".mobile-nav") &&
                  !$(target).parents().is(".mobile-nav")
                ) {
                  $("body").removeClass("mobile-nav-shown");
                }
              });
            }, 111);
          });
        } else {
          $("body").removeClass("mobile-nav-shown");
          $(".mobile-nav").removeClass("show");
        }
      });
      $(".header-container.type10 .dropdown-menu .menu-container>a").click(
        function () {
          if (
            !$("body").hasClass("template-index") ||
            $(".header-container.type10").hasClass("sticky-header")
          ) {
            if ($(this).next().find(".side-menu").hasClass("show")) {
              $(this).next().find(".side-menu").removeClass("show");
            } else {
              $(this).next().find(".side-menu").addClass("show");
            }
          }
          if ($(window).width() <= 991) {
            if ($(".mobile-nav").hasClass("show")) {
              $(".mobile-nav").removeClass("show");
              $(".mobile-nav").slideUp();
              $("body").removeClass("mobile-nav-shown");
            } else {
              $(".mobile-nav").addClass("show");
              $(".mobile-nav").slideDown();
              $("body").addClass("mobile-nav-shown", function () {
                setTimeout(function () {
                  $(document).one("click", function (e) {
                    var target = e.target;
                    if (
                      !$(target).is(".mobile-nav") &&
                      !$(target).parents().is(".mobile-nav")
                    ) {
                      $("body").removeClass("mobile-nav-shown");
                    }
                  });
                }, 111);
              });
            }
          }
        }
      );
      var breadcrumb_pos_top = 0;
      if ($(".header-container.type12").length > 0) {
        $("body").addClass("side-header");
      }
      $(window).scroll(function () {
        if (!$("body").hasClass("template-index")) {
          var side_header_height = $(".header-container.type12").innerHeight();
          var window_height = $(window).height();
          if (side_header_height - window_height < $(window).scrollTop()) {
            if (!$(".header-container.type12").hasClass("fixed-bottom"))
              $(".header-container.type12").addClass("fixed-bottom");
          }
          if (side_header_height - window_height >= $(window).scrollTop()) {
            if ($(".header-container.type12").hasClass("fixed-bottom"))
              $(".header-container.type12").removeClass("fixed-bottom");
          }
        }
        if ($("body.side-header .main-container .main-breadcrumbs").length) {
          if (
            !$("body.side-header .main-container .main-breadcrumbs").hasClass(
              "fixed-position"
            )
          ) {
            breadcrumb_pos_top = $(
              "body.side-header .main-container .main-breadcrumbs"
            ).offset().top;
            if (
              $("body.side-header .main-container .main-breadcrumbs").offset()
                .top < $(window).scrollTop()
            ) {
              $("body.side-header .main-container .main-breadcrumbs").addClass(
                "fixed-position"
              );
            }
          } else {
            if ($(window).scrollTop() <= 1) {
              $(
                "body.side-header .main-container .main-breadcrumbs"
              ).removeClass("fixed-position");
            }
          }
        }
      });
    },
  };
  SW.megamenu = {
    init: function () {
      $(
        ".main-navigation .top-navigation .static-dropdown .menu-wrap-sub, .main-navigation .top-navigation .m-dropdown .menu-wrap-sub"
      ).each(function () {
        $(this).css("left", "-9999px");
        $(this).css("right", "auto");
      });
      $(".main-navigation")
        .find("li.m-dropdown .menu-wrap-sub ul > li.parent")
        .mouseover(function () {
          var popup = $(this).children(".menu-wrap-sub");
          var w_width = $(window).innerWidth();

          if (popup) {
            var pos = $(this).offset();
            var c_width = $(popup).outerWidth();
            if (w_width <= pos.left + $(this).outerWidth() + c_width) {
              $(popup).css("left", "auto");
              $(popup).css("right", "100%");
              $(popup).css("border-radius", "6px 0 6px 6px");
            } else {
              $(popup).css("left", "100%");
              $(popup).css("right", "auto");
              $(popup).css("border-radius", "0 6px 6px 6px");
            }
          }
        });
      $(".main-navigation")
        .find("li.static-dropdown.parent,li.m-dropdown.parent")
        .mouseover(function () {
          var popup = $(this).children(".menu-wrap-sub");
          var w_width = $(window).innerWidth();
          if (popup) {
            var pos = $(this).offset();
            var c_width = $(popup).outerWidth();
            if (w_width <= pos.left + $(this).outerWidth() + c_width) {
              $(popup).css("left", "auto");
              $(popup).css("right", "0");
              $(popup).css("border-radius", "6px 0 6px 6px");
            } else {
              $(popup).css("left", "0");
              $(popup).css("right", "auto");
              $(popup).css("border-radius", "0 6px 6px 6px");
            }
          }
        });
      $(window).resize(function () {
        $(
          ".main-navigation .top-navigation .static-dropdown .menu-wrap-sub, .main-navigation .top-navigation .m-dropdown .menu-wrap-sub"
        ).each(function () {
          $(this).css("left", "-9999px");
          $(this).css("right", "auto");
        });
      });
    },
  };
  SW.slideshow = {
    init: function () {
      if ($(".slideshow.owl-carousel").length > 0) {
        var carousel = $(".slideshow.owl-carousel");
        carousel.each(function () {
          SW.slideshow.carouselInit($(this));
        });
        if ($(".full-screen-slider").length > 0) {
          SW.slideshow.fullScreenInit();
          $(window).resize(function () {
            SW.slideshow.fullScreenInit();
          });
        }
      }
    },
    carouselInit: function (carousel) {
      var data_carousel = carousel.parent().find(".data-slideshow");
      if (data_carousel.data("auto")) {
        var autoplay = true;
        var autoplayTime = data_carousel.data("auto");
      } else {
        var autoplay = false;
        var autoplayTime = 5000;
      }
      if (
        data_carousel.data("transition") == "fade" &&
        data_carousel.data("transition") != ""
      ) {
        var transition = "fadeOut";
      } else {
        var transition = false;
      }
      carousel.owlCarousel({
        items: 1,
        smartSpeed: 500,
        autoplay: autoplay,
        lazyLoad: true,
        autoplayTimeout: autoplayTime,
        autoplayHoverPause: true,
        animateOut: transition,
        dots: data_carousel.data("paging"),
        nav: data_carousel.data("nav"),
        navText: [data_carousel.data("prev"), data_carousel.data("next")],
      });
    },
    fullScreenInit: function () {
      var s_width = $(window).innerWidth();
      var s_height = $(window).innerHeight();
      var s_ratio = s_width / s_height;
      var v_width = 320;
      var v_height = 240;
      var v_ratio = v_width / v_height;
      $(".full-screen-slider div.item").css("position", "relative");
      $(".full-screen-slider div.item").css("overflow", "hidden");
      $(".full-screen-slider div.item").width(s_width);
      $(".full-screen-slider div.item").height(s_height);
      $(".full-screen-slider div.item > video").css("position", "absolute");
      $(".full-screen-slider div.item > video").bind(
        "loadedmetadata",
        function () {
          v_width = this.videoWidth;
          v_height = this.videoHeight;
          v_ratio = v_width / v_height;
          if (s_ratio >= v_ratio) {
            $(this).width(s_width);
            $(this).height("");
            $(this).css("left", "0px");
            $(this).css(
              "top",
              (s_height - (s_width / v_width) * v_height) / 2 + "px"
            );
          } else {
            $(this).width("");
            $(this).height(s_height);
            $(this).css(
              "left",
              (s_width - (s_height / v_height) * v_width) / 2 + "px"
            );
            $(this).css("top", "0px");
          }
          $(this).get(0).play();
        }
      );
    },
  };
  SW.page = {
    init: function () {
      if ($("body").find("#resultLoading").attr("id") != "resultLoading") {
        $("body").append(
          '<div id="resultLoading" style="display:none"><div class="spinner"><div class="circle"></i></div><div class="bg"></div></div>'
        );
      }
      if ($("#popup_newsletter").length > 0) {
        var newsletter = $("#popup_newsletter");
        SW.page.newsletterPopupInit(newsletter);
      }
      SW.page.setVisualState();
      $(".smart_input").on("change", function () {
        "use strict";
        SW.page.setVisualState();
      });
      SW.page.setSelect();
      if ($(".carousel-init.owl-carousel").length > 0) {
        var carousel = $(".carousel-init.owl-carousel");
        carousel.each(function () {
          SW.page.carouselInit($(this));
        });
      }
      $(".checkout-info .shipping a").click(function () {
        if ($(this).hasClass("collapsed")) {
          $(this).parent().removeClass("closed");
        } else {
          $(this).parent().addClass("closed");
        }
      });
      SW.page.wordRotateInit();
      SW.page.lazyLoadInit();
    },
    lazyLoadInit: function () {
      $(".lazy").lazyload({
        effect: "fadeIn",
        data_attribute: "src",
      });
    },
    newsletterPopupInit: function (newsletter) {
      $("#popup_newsletter .subcriper_label input").on("click", function () {
        if ($(this).parent().find("input:checked").length) {
          SW.collection.createCookie("newsletterSubscribe", "true", 1);
        } else {
          SW.collection.readCookie("newsletterSubscribe");
        }
      });
      $("#popup_newsletter .input-box button.button").on("click", function () {
        var button = $(this);
        setTimeout(function () {
          if (
            !button
              .parent()
              .find("input#popup-newsletter")
              .hasClass("validation-failed")
          ) {
            SW.collection.createCookie("newsletterSubscribe", "true", 1);
          }
        }, 500);
      });
      if (SW.collection.readCookie("newsletterSubscribe") == null) {
        setTimeout(function () {
          $.magnificPopup.open({
            items: {
              src: $("#popup_newsletter"),
              type: "inline",
            },
            mainClass: "mfp-move-from-top",
            removalDelay: 200,
            midClick: true,
          });
        }, newsletterData.delay);
      }
    },
    translateBlock: function (blockSelector) {
      if (multi_language && translator.isLang2()) {
        translator.doTranslate(blockSelector);
      }
    },
    translateText: function (str) {
      if (!multi_language || str.indexOf("|") < 0) return str;

      if (multi_language) {
        var textArr = str.split("|");
        if (translator.isLang2()) return textArr[1];
        return textArr[0];
      }
    },
    setVisualState: function () {
      "use strict";
      $(".smart_input").each(function () {
        "use strict";
        var $value = $(this).val();
        if ($(this).is(":checked")) {
          $(this).next().addClass("checked");
        } else {
          $(this).next().removeClass("checked");
        }
      });
    },
    setSelect: function () {
      "use strict";
      if ($.isFunction($.fn.selectize)) {
        if ($(".bootstrap-select").length) {
          $(".bootstrap-select").selectize();
        }
      }
    },
    carouselInit: function (carousel) {
      var data_carousel = carousel.parent().find(".data-carousel");
      if (data_carousel.data("auto")) {
        var autoplay = true;
        var autoplayTime = data_carousel.data("auto");
      } else {
        var autoplay = false;
        var autoplayTime = 5000;
      }
      if (data_carousel.data("320")) {
        var item_320 = data_carousel.data("320");
      } else {
        var item_320 = 1;
      }
      if (data_carousel.data("480")) {
        var item_480 = data_carousel.data("480");
      } else {
        var item_480 = 1;
      }
      if (data_carousel.data("640")) {
        var item_640 = data_carousel.data("640");
      } else {
        var item_640 = 1;
      }
      if (data_carousel.data("768")) {
        var item_768 = data_carousel.data("768");
      } else {
        var item_768 = 1;
      }
      if (data_carousel.data("992")) {
        var item_992 = data_carousel.data("992");
      } else {
        var item_992 = 1;
      }
      if (data_carousel.data("1200")) {
        var item_1200 = data_carousel.data("1200");
      } else {
        var item_1200 = 1;
      }
      carousel.owlCarousel({
        items: data_carousel.data("items"),
        smartSpeed: 500,
        lazyLoad: true,
        autoplay: autoplay,
        autoplayTimeout: autoplayTime,
        autoplayHoverPause: true,
        dots: data_carousel.data("paging"),
        margin: data_carousel.data("margin"),
        nav: data_carousel.data("nav"),
        navText: [data_carousel.data("prev"), data_carousel.data("next")],
        responsive: {
          0: {
            items: item_320,
          },
          480: {
            items: item_480,
          },
          640: {
            items: item_640,
          },
          768: {
            items: item_768,
          },
          992: {
            items: item_992,
          },
          1200: {
            items: item_1200,
          },
        },
      });
    },
    wordRotateInit: function () {
      $(".word-rotate").each(function () {
        var $this = $(this),
          itemsWrapper = $(this).find(".word-rotate-items"),
          items = itemsWrapper.find("> span"),
          firstItem = items.eq(0),
          firstItemClone = firstItem.clone(),
          itemHeight = 0,
          currentItem = 1,
          currentTop = 0;
        itemHeight = firstItem.height();
        itemsWrapper.append(firstItemClone);
        $this.height(itemHeight).addClass("active");
        setInterval(function () {
          currentTop = currentItem * itemHeight;
          itemsWrapper.animate(
            {
              top: -currentTop + "px",
            },
            300,
            function () {
              currentItem++;
              if (currentItem > items.length) {
                itemsWrapper.css("top", 0);
                currentItem = 1;
              }
            }
          );
        }, 2000);
      });
    },
  };
  SW.collection = {
    init: function () {
      SW.collection.productGridSetup();
      if ($(".product-deal .product-date").length > 0) {
        var productsDeal = $(".product-date");
        productsDeal.each(function () {
          SW.collection.productDealInit($(this));
        });
      }
      SW.collection.layoutSwitch();
      if (SW.collection.readCookie("products-listmode") != null) {
        SW.collection.layoutListInit();
      }
      $(document).on("click", ".close-box", function () {
        $(this).parents(".box-popup").removeClass("show");
      });
      $(document).on("click", ".add-to-wishlist", function (e) {
        e.preventDefault();
        SW.collection.addToWishlist($(this));
      });
      $(document).on("click", ".remove-wishlist", function (e) {
        e.preventDefault();
        SW.collection.removeWishlist($(this));
      });
      $(document).on("click", ".btn-remove-cart", function (e) {
        e.preventDefault();
        // SW.collection.removeCartInit($(this).data('id'));
        SW.collection.removeCartItem($(this).data("id"));
      });
      $(document).on("click", ".filter-bar a", function (e) {
        e.preventDefault();
        if ($(".filter-option-group").is(".open")) {
          $(".filter-option-group").removeClass("open");
        } else {
          $(".filter-option-group").addClass("open");
        }
      });
      $('a[data-toggle="tab"]').on("shown.bs.tab", function (e) {
        var $tab = $(this).attr("href");
        $($tab)
          .find("img[data-src]")
          .each(function () {
            $(this).attr("src", $(this).attr("data-src"));
          });
      });
      /* moving action links into product image area */
      $(".move-action .item .details-area .actions").each(function () {
        $(this)
          .parents(".item-area")
          .children(".product-image-area")
          .append($(this));
      });
      $("[data-with-product]").each(function () {
        SW.collection.prevNextProductData($(this));
      });
      // Disabled cart functions
      SW.collection.initCartFunctions();
      if (jQuery("div.checkout-cart").length) {
        SW.collection.initCartEvaluator();
      }
      SW.collection.addToCart();
      SW.collection.addToCart2();
      SW.collection.addToCart3();

      SW.collection.quickshopInit();
      SW.collection.sidebarMenuInit();
      SW.collection.layerFilterInit();
      //       SW.collection.colorSwatchGridInit();
      SW.collection.tabInfinityScrollInit();
      //       SW.collection.countDowntInit();
      SW.collection.initInfiniteScrolling();
      SW.collection.sidebarInitToggle();
      SW.collection.sidebarCategoryInitToggle();
    },
    createCookie: function (name, value, days) {
      var expires;
      if (days) {
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toGMTString();
      } else {
        expires = "";
      }
      document.cookie =
        escape(name) + "=" + escape(value) + expires + "; path=/";
    },
    readCookie: function (name) {
      var nameEQ = escape(name) + "=";
      var ca = document.cookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === " ") c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0)
          return unescape(c.substring(nameEQ.length, c.length));
      }
      return null;
    },
    eraseCookie: function (name) {
      SW.collection.createCookie(name, "", -1);
    },
    productGridSetup: function () {
      $(".category-products .products-grid li.item:nth-child(2n)").addClass(
        "nth-child-2n"
      );
      $(".category-products .products-grid li.item:nth-child(2n+1)").addClass(
        "nth-child-2np1"
      );
      $(".category-products .products-grid li.item:nth-child(3n)").addClass(
        "nth-child-3n"
      );
      $(".category-products .products-grid li.item:nth-child(3n+1)").addClass(
        "nth-child-3np1"
      );
      $(".category-products .products-grid li.item:nth-child(4n)").addClass(
        "nth-child-4n"
      );
      $(".category-products .products-grid li.item:nth-child(4n+1)").addClass(
        "nth-child-4np1"
      );
      $(".category-products .products-grid li.item:nth-child(5n)").addClass(
        "nth-child-5n"
      );
      $(".category-products .products-grid li.item:nth-child(5n+1)").addClass(
        "nth-child-5np1"
      );
      $(".category-products .products-grid li.item:nth-child(6n)").addClass(
        "nth-child-6n"
      );
      $(".category-products .products-grid li.item:nth-child(6n+1)").addClass(
        "nth-child-6np1"
      );
      $(".category-products .products-grid li.item:nth-child(7n)").addClass(
        "nth-child-7n"
      );
      $(".category-products .products-grid li.item:nth-child(7n+1)").addClass(
        "nth-child-7np1"
      );
      $(".category-products .products-grid li.item:nth-child(8n)").addClass(
        "nth-child-8n"
      );
      $(".category-products .products-grid li.item:nth-child(8n+1)").addClass(
        "nth-child-8np1"
      );
    },
    colorSwatchGridInit: function () {
      $(".configurable-swatch-list li a").on("mouseenter", function (e) {
        e.preventDefault();
        var productImage = $(this)
          .parents(".item-area")
          .find(".product-image-area")
          .find(".product-image");
        productImage.find("img.main").attr("src", $(this).data("image"));
      });
    },
    animateItems: function (productsInstance) {
      productsInstance.find(".product").each(function (aj) {
        $(this).css("opacity", 1);
        $(this).addClass("item-animated");
        $(this)
          .delay(aj * 200)
          .animate(
            {
              opacity: 1,
            },
            500,
            "easeOutExpo",
            function () {
              $(this).addClass("item-animated");
            }
          );
      });
    },
    layoutSwitch: function () {
      var isSwitchingLayout = false;
      $(document).on("click", "span.layout-opt", function (e) {
        var products = $("#products-grid"),
          selectedLayout = $(this).data("layout");

        $(".toolbar .view-mode .layout-opt").removeClass("active");
        $(this).addClass("active");
        if (selectedLayout == "list") {
          if (SW.collection.readCookie("products-listmode") == null) {
            SW.collection.createCookie("products-listmode", 1, 10);
          }
        } else {
          SW.collection.eraseCookie("products-listmode");
        }
        if (isSwitchingLayout) {
          return;
        }
        isSwitchingLayout = true;
        products.animate(
          {
            opacity: 0,
          },
          300
        );
        setTimeout(function () {
          products
            .find(".product")
            .removeClass("product-layout-list product-layout-grid");
          products
            .find(".product")
            .addClass("product-layout-" + selectedLayout);
          if ($(".products-grid").length > 0) {
            $(".products-grid").children().css("min-height", "0");
          }
          SW.collection.productGridSetup();
          products.animate(
            {
              opacity: 1,
            },
            200
          );
          isSwitchingLayout = false;
        }, 300);
        e.preventDefault();
      });
    },
    layoutListInit: function () {
      var products = $("#products-grid");
      products.css("opacity", 0);
      $('.toolbar .view-mode span[data-layout="grid"]').removeClass("active");
      $('.toolbar .view-mode span[data-layout="list"]').addClass("active");
      products
        .find(".product")
        .removeClass("product-layout-list product-layout-grid");
      products.find(".product").addClass("product-layout-list");
      setTimeout(function () {
        products.animate(
          {
            opacity: 1,
          },
          200
        );
      }, 300);
    },
    productDealInit: function (productDeal) {
      var date = productDeal.data("date");
      if (date) {
        var config = { date: date };
        $.extend(config, countdown);
        $.extend(config, countdownConfig);
        if (countdownTemplate) {
          config.template = countdownTemplate;
        }
        productDeal.countdown(config);
      }
    },
    quickshopInit: function () {
      $(document).on("initproduct", "#product-form", function () {
        var product_handle = $(this).data("id");
        var template = $(".product-view");
        Shopify.getProduct(product_handle, function (product) {
          template.find(".product-shop").attr("id", "product-" + product.id);
          template
            .find(".product-form")
            .attr("id", "product-actions-" + product.id);
          template
            .find(".product-form .product-options select")
            .attr("id", "product-select-" + product.id);
          SW.collection.createSwatch(product, template);
        });
      });
      $("#product-form").trigger("initproduct");
      $(document).on("click", ".quickview", function () {
        var $prod = $(this).closest(".product");
        eval($prod.find("[data-id^=product-block-json-]").html());
        var template = $prod.find("[data-id^=product-block-template-]").html();
        return $.magnificPopup.open({
          items: {
            src: [template].join(""),
            type: "inline",
          },
          mainClass: "mfp-move-from-top",
          removalDelay: 200,
          midClick: true,
          preloader: true,
          callbacks: {
            open: function () {
              SW.verticleScroll.init();
              if ($(".carousel-init.owl-carousel").length > 0) {
                var carousel = $(".carousel-init.owl-carousel");
                carousel.each(function () {
                  SW.page.carouselInit($(this));
                });
              }
              SW.productMediaManager.init();
              $("#product-form").trigger("initproduct");
              SW.collection.countDowntInit();
              SW.page.translateBlock(".quick-view");
              if (frontendData.enableCurrency) {
                currenciesCallbackSpecial(".quick-view span.money");
              }
              if ($(".spr-badge").length > 0) {
                SPR.registerCallbacks();
                SPR.initRatingHandler();
                SPR.initDomEls();
                SPR.loadProducts();
                SPR.loadBadges();
              }
            },
            close: function () {
              SW.productMediaManager.destroyZoom();
            },
          },
        });
      });
    },
    createSwatch: function (product, layout) {
      if (product.variants.length >= 1) {
        //multiple variants
        for (var i = 0; i < product.variants.length; i++) {
          var variant = product.variants[i];
          var option =
            '<option value="' + variant.id + '">' + variant.title + "</option>";
          layout.find("form.product-form > select").append(option);
        }
        new Shopify.OptionSelectors("product-select-" + product.id, {
          product: product,
          onVariantSelected: SW.collection.selectCallback,
        });

        //start of quickview variant;
        var filePath = asset_url.substring(0, asset_url.lastIndexOf("/"));
        var assetUrl = asset_url.substring(0, asset_url.lastIndexOf("/"));
        var options = "";
        for (var i = 0; i < product.options.length; i++) {
          options +=
            '<div class="swatch clearfix" data-option-index="' + i + '">';
          options +=
            '<div class="header">' + product.options[i].name + "</div>";
          var is_color = false;
          if (/Colozr|Colouzr/i.test(product.options[i].name)) {
            is_color = true;
          }
          var optionValues = new Array();
          for (var j = 0; j < product.variants.length; j++) {
            var variant = product.variants[j];
            var value = variant.options[i];
            var available = variant.available;
            if (variant.featured_image) {
              var img = variant.featured_image.src.lastIndexOf(".");
              var vimg =
                variant.featured_image.src.slice(0, img) +
                "_38x" +
                variant.featured_image.src.slice(img);
            } else {
              var vimg = "";
            }
            var valueHandle = SW.collection.convertToSlug(value);
            var forText = "swatch-" + i + "-" + valueHandle;
            if (optionValues.indexOf(value) < 0) {
              //not yet inserted
              options +=
                '<div data-value="' +
                value +
                '" class="swatch-element ' +
                (is_color ? "color" : "") +
                " " +
                (is_color ? "color" : "") +
                valueHandle +
                (variant.available ? " available " : " soldout ") +
                '">';

              if (is_color) {
                options += '<div class="tooltip">' + value + "</div>";
              }
              options +=
                '<input id="' +
                forText +
                '" type="radio" name="option-' +
                i +
                '" value="' +
                value +
                '" ' +
                (j == 0 ? " checked " : "") +
                (variant.available ? "" : " disabled") +
                " />";

              if (is_color) {
                if (vimg) {
                  options +=
                    '<label for="' +
                    forText +
                    '" style="overflow:hidden;"><img src="' +
                    vimg +
                    '" class="variant-image" style="max-width:100%;" /><img class="crossed-out" src="' +
                    assetUrl +
                    'soldout.png" /></label>';
                } else {
                  options +=
                    '<label for="' +
                    forText +
                    '" style="background-color: ' +
                    valueHandle +
                    "; background-image: url(" +
                    filePath +
                    valueHandle +
                    '.png)"><img class="crossed-out" src="' +
                    assetUrl +
                    'soldout.png" /></label>';
                }
              } else {
                if (available) {
                  options +=
                    '<label for="' +
                    forText +
                    '">' +
                    value +
                    '<img class="crossed-out" src="' +
                    assetUrl +
                    'soldout.png" /></label>';
                } else {
                  options +=
                    '<a href="#" class="klaviyo-bis-trigger"><label for="' +
                    forText +
                    '" style="min-width:100px !important;">' +
                    value +
                    ' <span style="background:white;color:red;font-size:10px;font-weight:bold;position:absolute;top:-7px;left: calc(50% - 29px);line-height:10px;">(Sold Out)</span> <img class="crossed-out" src="' +
                    assetUrl +
                    'soldout.png" /></label></a>';
                }
              }
              options += "</div>";
              if (variant.available) {
                $(
                  '.product-view .swatch[data-option-index="' +
                    i +
                    '"] .' +
                    valueHandle
                )
                  .removeClass("soldout")
                  .addClass("available")
                  .find(":radio")
                  .removeAttr("disabled");
              }
              optionValues.push(value);
            }
          }
          options += "</div>";
        }
        if (swatch_color_enable) {
          layout
            .find("form.product-form .product-options > select")
            .after(options);
          layout.find(".swatch :radio").change(function () {
            var optionIndex = $(this)
              .closest(".swatch")
              .attr("data-option-index");
            var optionValue = $(this).val();
            $(this)
              .closest("form")
              .find(".single-option-selector")
              .eq(optionIndex)
              .val(optionValue)
              .trigger("change");
          });
        }
        if (product.available) {
          Shopify.optionsMap = {};
          Shopify.linkOptionSelectors(product);
        }

        //end of quickview variant
      } else {
        //single variant
        layout.find("form.product-form .product-options > select").remove();
        var variant_field =
          '<input type="hidden" name="id" value="' +
          product.variants[0].id +
          '">';
        layout.find("form.product-form").append(variant_field);
      }
    },
    convertToSlug: function (e) {
      return e
        .toLowerCase()
        .replace(/[^a-z0-9 -]/g, "")
        .replace(/\s+/g, "-")
        .replace(/-+/g, "-");
    },
    getFileNameFromURL: function (url) {
      var pathArray = url.split("/");
      var filename = pathArray[pathArray.length - 1];
      return filename;
    },
    selectCallback: function (variant, selector) {
      if (variant) {
        if (variant.available) {
          $("#price")
            .addClass("sas-price price")
            .attr("data-show-currency", true);
          if (variant.compare_at_price > variant.price) {
            $("#price").html(
              '<del class="price_compare sas-money">' +
                SW.currency.formatMoney(variant.compare_at_price) +
                "</del>" +
                '<div class="price sas-money">' +
                SW.currency.formatMoney(variant.price, true) +
                "</div>"
            );
          } else {
            $("#price").html(
              '<div class="price sas-money">' +
                SW.currency.formatMoney(variant.price, true) +
                "</div>"
            );
          }
          frontendData.enableCurrency &&
            currenciesCallbackSpecial("#price span.money"),
            $(".product-shop-wrapper .add-to-cart")
              .removeClass("disabled")
              .removeAttr("disabled")
              .html(window.inventory_text.add_to_cart),
            variant.inventory_management && variant.inventory_quantity <= 0
              ? ($("#selected-variant").html(
                  selector.product.title + " - " + variant.title
                ),
                $("#backorder").removeClass("hidden"))
              : $("#backorder").addClass("hidden");
          if (variant.inventory_management != null) {
            $(".product-inventory span.in-stock").text(
              window.inventory_text.in_stock
            );
          } else {
            $(".product-inventory span.in-stock").text(
              window.inventory_text.many_in_stock
            );
          }
          $(".product-sku span.sku").text(variant.sku);
        } else {
          $("#backorder").addClass("hidden"),
            $(".product-shop-wrapper .add-to-cart")
              .html(window.inventory_text.sold_out)
              .addClass("disabled")
              .attr("disabled", "disabled");
          $(".product-inventory span.in-stock").text(
            window.inventory_text.out_of_stock
          );
          $(".product-sku span.sku").empty();
        }
        if (swatch_color_enable) {
          var form = $("#" + selector.domIdPrefix).closest("form");
          for (var i = 0, length = variant.options.length; i < length; i++) {
            var radioButton = form.find(
              '.swatch[data-option-index="' +
                i +
                '"] :radio[value="' +
                variant.options[i] +
                '"]'
            );
            if (radioButton.size()) {
              radioButton.get(0).checked = true;
            }
          }
        }
      }
      if (variant && variant.featured_image) {
        var n = Shopify.Image.removeProtocol(variant.featured_image.src);
        n = SW.collection.getFileNameFromURL(n);
        $(".product-image-thumbs .thumb-link")
          .filter('[data-zoom-image*="' + n + '"]')
          .trigger("click");
      }
      variant && variant.sku
        ? $("#sku").removeClass("hidden").find("span").html(variant.sku)
        : $("#sku").addClass("hidden").find("span").html("");
    },
    prevNextProductData: function (el) {
      var e = el.data("with-product"),
        t = el.find('script[type="text/template"]'),
        i = t.html();
      $.getJSON("/products/" + e + ".json", function (e) {
        var a = e.product;
        for (var o in a)
          i = i.replace(new RegExp("\\[" + o + "\\]", "ig"), a[o]);
        var r = a.image.src.lastIndexOf(".");
        (i = i.replace(
          /\[img:([a-z]*)\]/gi,
          a.image.src.slice(0, r) + "_$1" + a.image.src.slice(r)
        )),
          t.replaceWith(i);
      });
    },
    addToWishlist: function (wishlist) {
      var form = wishlist.parents("form").serialize(),
        id = wishlist.data("id"),
        all = $("body").find(".wishlist-" + id + " .add-to-wishlist");
      $.ajax({
        type: "POST",
        url: "/contact",
        async: !0,
        data: form,
        cache: !1,
        beforeSend: function () {
          $("#resultLoading").show();
        },
        success: function () {
          var productInfo = wishlist.closest(".product"),
            box = $("#wishlist-box");
          box
            .find(".product-link")
            .attr("href", productInfo.find(".product-name a").attr("href")),
            box
              .find(".product-img")
              .attr("src", productInfo.find(".product-image img").attr("src"))
              .attr("alt", productInfo.find(".product-name a").html()),
            box
              .find(".product-title .product-link")
              .html(productInfo.find(".product-name a").html()),
            box.find(".product-price").html(productInfo.find(".price").html());
          all.each(function () {
            $(this)
              .removeClass("add-to-wishlist")
              .addClass("added")
              .attr("title", $(this).attr("data-added")),
              $(this).find("span").html($(this).attr("data-added"));
            //$(this).find("i").removeClass("fa-heart-o").addClass("fa-heart");
          }),
            setTimeout(function () {
              $("#resultLoading").hide();
              box.addClass("show"),
                setTimeout(function () {
                  box.removeClass("show");
                }, 5e3);
            }, 500);
        },
        error: function (t) {
          var box = $("#error-notice"),
            i = $.parseJSON(t.responseText);
          box.find(".heading").html(i.message),
            box.find(".message").html(i.description),
            setTimeout(function () {
              $("#resultLoading").hide(),
                box.addClass("show"),
                setTimeout(function () {
                  box.removeClass("show");
                }, 5e3);
            }, 500);
        },
      });
    },
    removeWishlist: function (wishlist) {
      var form = wishlist.parents("form").serialize(),
        item = wishlist.parents(".item");
      $.ajax({
        type: "POST",
        url: "/contact",
        data: form,
        beforeSend: function () {
          $("#resultLoading").show();
        },
        success: function () {
          $("#resultLoading").hide(), item.fadeOut(500);
        },
        error: function () {
          var box = $("#error-notice"),
            i = $.parseJSON(t.responseText);
          box.find(".heading").html(i.message),
            box.find(".message").html(i.description),
            setTimeout(function () {
              $("#resultLoading").hide(),
                box.addClass("show"),
                setTimeout(function () {
                  box.removeClass("show");
                }, 5e3);
            }, 500);
        },
      });
    },
    customAddUpsell: function (id, quantity) {
      Shopify.addItem(
        id,
        quantity,
        {},
        {
          success: function (data, textStatus, jqXHR) {
            alert("Added!");
          },
          error: function (jqXHR, textStatus, errorThrown) {
            alert("Error: " + errorThrown + "!");
          },
        }
      );
    },
    checkCart: function (cart, id, quantity) {
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].product_id == id) {
          if (cart.items[i].quantity == quantity) {
            carted = true;

            return true;
            break;
          }
        }
      }
    },
    addToCart: function () {
      $(document).on("click", ".add-to-cart", function (e) {
        e.preventDefault();
        var a = $(this);
        var form = a.closest("form");
        return $.ajax({
          type: "POST",
          url: "/cart/add.js",
          async: !0,
          data: form.serialize(),
          dataType: "json",
          beforeSend: function () {
            if (a.parents(".item-area").length > 0) {
              a.parents(".item-area").find(".loader-container").show();
            } else {
              $("#resultLoading").show();
            }
          },
          error: function (t) {
            var box = $("#error-notice"),
              i = $.parseJSON(t.responseText);
            box.find(".heading").html(i.message);
            box.find(".message").html(i.description);
            setTimeout(function () {
              $(".loader-container").hide();
              $("#resultLoading").hide();
              box.addClass("show");
              setTimeout(function () {
                box.removeClass("show");
              }, 5e3);
            }, 5000);
          },
          success: function (t) {
            Shopify.getCart(function (e) {
              var i = parseInt(form.find('input[name="quantity"]').val()),
                box = $("#cart-box");
              box.find(".product-link").attr("href", t.url),
                box
                  .find(".product-img")
                  .attr("src", Shopify.resizeImage(t.image, "medium"))
                  .attr("alt", SW.page.translateText(t.title)),
                box
                  .find(".product-title .product-link")
                  .html(SW.page.translateText(t.title)),
                box
                  .find(".product-price")
                  .html(Shopify.formatMoney(t.price, money_format)),
                frontendData.enableCurrency &&
                  currenciesCallbackSpecial("#cart-box span.money");
              setTimeout(function () {
                $(".loader-container").hide();
                $("#resultLoading").hide();
                box.addClass("show");
                setTimeout(function () {
                  box.removeClass("show");
                  window.location.href = "/cart";
                }, 20e3);
              }, 500),
                SW.collection.updateCartInfo(
                  e,
                  ".cart-container .cart-wrapper .cart-inner-content"
                );
            });
            return false;
          },
          cache: !1,
        });
      });
    },
    initCartFunctions: function () {
      Shopify.updateCartItems = function (data, cb) {
        var request = {
          type: "POST",
          url: "/cart/update.js",
          data: { updates: data },
          dataType: "json",
          success: function (e) {
            "function" == typeof cb ? cb(e) : Shopify.onCartUpdate(e);
          },
          error: function (e, t) {
            Shopify.onError(e, t);
          },
        };
        jQuery.ajax(request);
      };
    },
    initCartEvaluator: function () {
      var evalCart = jQuery.debounce(4000, true, function (target) {
        SW.collection.evalCart(target);
      });

      var inputHandler = jQuery.debounce(250, function (input, e) {
        if (+$(input).val() > 0) {
          SW.collection.updateCart($(input).data("variantId"), $(input).val());
        }
      });

      var submitHandler = function (e) {
        e.preventDefault();
        e.stopPropagation();
        evalCart("form#cart-form");
      };

      // jQuery('form#cart-form').one('submit', submitHandler );

      // jQuery('button[type=submit]').one('click', function(e){
      //   e.preventDefault();
      //   e.stopPropagation();
      //   // jQuery('form#cart-form').off('submit', submitHandler );
      //   // evalCart( 'button[type=submit]' );
      //   jQuery('form#cart-form').off('submit', submitHandler );
      //   jQuery('form#cart-form').off('submit', false );
      //   jQuery('input[type=submit]').click();
      // });

      // jQuery('input[type=submit]').one('click', function(e){
      //   e.preventDefault();
      //   e.stopPropagation();
      //   // jQuery('form#cart-form').off('submit', submitHandler );
      //   // evalCart( 'input[type=submit]' );
      //   jQuery('form#cart-form').off('submit', submitHandler );
      //   jQuery('form#cart-form').off('submit', false );
      //   jQuery('input[type=submit]').click();
      // });

      jQuery(".qty-input").on("keypress", function (e) {
        if (e.which === 13) {
          e.preventDefault();
          e.stopPropagation();
          // jQuery('form#cart-form').off('submit', submitHandler );
          // jQuery('form#cart-form').on('submit', false );

          // if ( +$(this).val() > 0 ) {
          //   setTimeout( function() {
          //     jQuery('input[type=submit]').click();
          //   }, 750 );
          // }
        }

        if (e.which >= 48 && e.which <= 57) {
          inputHandler(this, e);
        }
      });

      SW.collection.evalCart();
    },
    cartEUMap: {
      32508182537: 6990880899123,
      //       32843866569: 6990896037939,
      32734717897: 6990888337459,
    },
    cartUpsellRules: [
      {
        variant_id: 32508182537,
        min: 1,
        max: 1,
        geo: ["US"],
        link: "https://www.stealthangelsurvival.com/a/secure/checkout/6fz9FjfZFetQhqy6JIpF",
      },
      {
        variant_id: 32508182537,
        min: 1,
        max: 1,
        geo: ["GB"],
        link: "https://www.stealthangelsurvival.com/a/secure/checkout/v7R7YrDJcV3e1s4C3Meb",
      },
      {
        variant_id: 32508182537,
        min: 1,
        max: 1,
        geo: ["AU"],
        link: "https://www.stealthangelsurvival.com/a/secure/checkout/v7R7YrDJcV3e1s4C3Meb",
      },
      {
        variant_id: 330498015241,
        min: 1,
        max: 1,
        geo: ["US"],
        link: "https://www.stealthangelsurvival.com/a/secure/checkout/f8tg14a5rtbq5WG0iScm",
      },
    ],
    cartIsEUReady: function () {
      var cart = SW.collection.cartItems();
      var euMap = SW.collection.cartEUMap;
      var cart_ids = $.map(cart, function (v, k) {
        return k;
      });
      var eu_ids = cart_ids.reduce(function (acc, v) {
        if (euMap[v]) acc.push(v);
        return acc;
      }, []);
      return cart_ids.length === eu_ids.length;
    },
    getEUCart() {
      var cart = SW.collection.cartItems();
      var euMap = SW.collection.cartEUMap;
      var cart_ids = $.map(cart, function (v, k) {
        return k;
      });
      return cart_ids.reduce(function (acc, k) {
        acc[euMap[k]] = cart[k];
        return acc;
      }, {});
    },
    getEUCartLink() {
      var cart_url = "https://eu.stealthangelsurvival.com/cart/";
      var cart_params = $.map(SW.collection.getEUCart(), function (v, k) {
        return [k, v].join(":");
      }).join(",");
      return cart_url + cart_params;
    },
    handleEUCart() {
      return SW.currency.getLocale().done(function (locale) {
        if (locale.country_code === "ES") {
          if (SW.collection.cartIsEUReady()) {
            var cart_link = SW.collection.getEUCartLink();
            SW.collection.replaceCheckout(cart_link);
          }
        }
      });
    },
    includes(haystack, needle) {
      if (haystack.length < 1) return false;
      var i;
      for (i = 0; i < haystack.length; i++) {
        if (haystack[i] === needle) return true;
      }
      return false;
    },
    matchCartUpsell(geo) {
      var cart = SW.collection.upsellCartItems();
      var variants = Object.keys(cart);
      var result = {
        match: false,
        link: null,
      };

      if (variants.length !== 1) return result;

      var variant_id = variants[0];
      var qty = cart[variant_id] || 0;
      var rules = SW.collection.cartUpsellRules;

      return rules.reduce(function (acc, rule) {
        var t1 = rule.variant_id == variant_id;
        var t2 = qty >= rule.min && qty <= rule.max;
        var t3 = SW.collection.includes(rule.geo, geo);
        if (t1 && t2 && t3) {
          acc.match = true;
          acc.link = rule.link;
        }

        return acc;
      }, result);
    },
    handleUpsellCart() {
      return SW.currency.getLocale().done(function (locale) {
        var upsell = SW.collection.matchCartUpsell(locale.country_code);

        if (upsell.match) {
          SW.collection.replaceCheckout(upsell.link);
        } else {
          SW.collection.restoreCheckout();
        }
      });
    },
    replaceCheckout(cart_link) {
      if (!$("#checkout-replace").length) {
        var el = $("ul.checkout-types").clone().attr("id", "checkout-replace");
        $("ul.checkout-types").css("display", "none").before(el);
      }

      var checkoutSection = [
        $("<li></li>").html(
          $("<a></a>", {
            class: "btn-button cart-button-lock",
            style: "text-decoration: none; width: 100%;",
            href: cart_link,
          }).html(" Proceed to checkout")
        ),
        $("<li></li>").html("Or Pay With"),
        $("<li></li>").html(
          $("<div></div>", { class: "additional-checkout-buttons" }).html(
            $("<a></a>", {
              class:
                "additional-checkout-button--paypal-express additional-checkout-button",
              style: "display: inline-block; margin-left: 10px;",
              href: cart_link,
            }).html(
              $("<img/>", {
                src: "//cdn.shopify.com/s/assets/checkout/easy-checkout-btn-paypal-9835af2c2b0e2a543b2905789a7f08b678d62de2c77c1b0d16fd7689aff463f3.png",
              })
            )
          )
        ),
      ];

      $("#checkout-replace").html(checkoutSection);
    },
    restoreCheckout() {
      if ($("#checkout-replace").length) {
        $("#checkout-replace").remove();

        $("ul.checkout-types").css("display", "block");
      }
    },
    cartRules: {
      32508182537: [
        { min: 3, max: false, bonuses: [{ id: 32734717897, qty: 1 }] },
        //         { min: 2, max: 2, bonuses: [{ id: 32843866569, qty: 1 }] },
        // { min: 2, max: 2, bonuses: [{ id: 34359890953, qty: 1 }] },
      ],
      33989910025: [
        //         { min: 3, max: false, bonuses: [{ id: 33990758025, qty: 1 }] },
        //         { min: 2, max: 2, bonuses: [{ id: 32843866569, qty: 1 }] },
        // { min: 2, max: 2, bonuses: [{ id: 34359890953, qty: 1 }] },
      ],
      32937641865: [
        //         { min: 3, max: false, bonuses: [{ id: 34621248521, qty: 1 }] },
        //         { min: 2, max: 2, bonuses: [{ id: 32843866569, qty: 1 }] },
        // { min: 2, max: 2, bonuses: [{ id: 34359890953, qty: 1 }] },
      ],
      29560431433: [
        // { min: 2, max: false, bonuses: [{ id: 34359890953, qty: 1 }] },
      ],
      28619651465: [
        { min: 2, max: 2, bonuses: [{ id: 35282544009, qty: 1 }] },
        { min: 3, max: false, bonuses: [{ id: 35282544009, qty: 2 }] },
      ],
      38908526985: [
        { min: 3, max: false, bonuses: [{ id: 38909838985, qty: 1 }] },
      ],
      //       32509832265: [
      //         { min: 3, max: false, bonuses: [{ id: 40459054985, qty: 1 }] },
      //       ],
      330498015241: [
        { min: 2, max: 2, bonuses: [{ id: 1627806826505, qty: 1 }] },
        { min: 3, max: false, bonuses: [{ id: 1627806826505, qty: 2 }] },
      ],
      45396427401: [
        //         { min: 3, max: false, bonuses: [{ id: 32843866569, qty: 1 }] },
      ],
      91715207177: [
        //         { min: 2, max: false, bonuses: [{ id: 32843866569, qty: 1 }] },
      ],
      1838788411401: [
        { min: 2, max: 2, bonuses: [{ id: 8113498325098, qty: 1 }] },
        { min: 3, max: false, bonuses: [{ id: 8113498325098, qty: 2 }] },
      ],
      906239279113: [
        { min: 2, max: 2, bonuses: [{ id: 12220404564062, qty: 1 }] },
        { min: 3, max: false, bonuses: [{ id: 12220404564062, qty: 2 }] },
      ],
      31550291738718: [
        { min: 2, max: 2, bonuses: [{ id: 31777412284510, qty: 1 }] },
        { min: 3, max: false, bonuses: [{ id: 31777412284510, qty: 2 }] },
      ],
    },
    cartOffers: {
      32508182537: [
        //         {
        //           min: 1,
        //           max: 1,
        //           btn_text: "Add 1 More",
        //           link_text: " and get a Free Paracord Bracelet",
        //           qty: 1,
        //           variant_id: 32508182537,
        //         },
        // {
        //   min: 1,
        //   max: 1,
        //   btn_text: "Add 1 More",
        //   link_text: " and get a Free 7-in-1 Multi-Tool",
        //   qty: 1,
        //   variant_id: 32508182537,
        // },
        {
          min: 1,
          max: 1,
          btn_text: "Add 2 More",
          link_text: " and get the 4th Kit for Free",
          qty: 2,
          variant_id: 32508182537,
        },
        {
          min: 2,
          max: 2,
          btn_text: "Add 1 More",
          link_text: " and get the 4th Kit for Free",
          qty: 1,
          variant_id: 32508182537,
        },
      ],
      31550291738718: [
        {
          min: 1,
          max: 1,
          btn_text: "Add 1 More",
          link_text: " and get the 1 Free DocFortress",
          qty: 1,
          variant_id: 31550291738718,
        },
        {
          min: 1,
          max: 1,
          btn_text: "Add 2 More",
          link_text: " and get the 2 Free DocFortress",
          qty: 2,
          variant_id: 31550291738718,
        },
        {
          min: 2,
          max: 2,
          btn_text: "Add 1 More",
          link_text: " and get the 2 Free DocFortress",
          qty: 1,
          variant_id: 31550291738718,
        },
      ],
      33989910025: [
        // {
        //   min: 1,
        //   max: 1,
        //   btn_text: "Add 1 More",
        //   link_text: " and get a Free 7-in-1 Multi-Tool",
        //   qty: 1,
        //   variant_id: 33989910025,
        // },
        //         {
        //           min: 1,
        //           max: 1,
        //           btn_text: "Add 1 More",
        //           link_text: " and get a Free Paracord Bracelet",
        //           qty: 1,
        //           variant_id: 33989910025,
        //         },
        {
          min: 1,
          max: 1,
          btn_text: "Add 2 More",
          link_text: " and get the 4th Kit for Free",
          qty: 2,
          variant_id: 33989910025,
        },
        {
          min: 2,
          max: 2,
          btn_text: "Add 1 More",
          link_text: " and get the 4th Kit for Free",
          qty: 1,
          variant_id: 33989910025,
        },
      ],
      32937641865: [
        // {
        //   min: 1,
        //   max: 1,
        //   btn_text: "Add 1 More",
        //   link_text: " and get a Free 7-in-1 Multi-Tool",
        //   qty: 1,
        //   variant_id: 32937641865,
        // },
        //         {
        //           min: 1,
        //           max: 1,
        //           btn_text: "Add 1 More",
        //           link_text: " and get a Free Paracord Bracelet",
        //           qty: 1,
        //           variant_id: 32937641865,
        //         },
        {
          min: 1,
          max: 1,
          btn_text: "Add 2 More",
          link_text: " and get the 4th Kit for Free",
          qty: 2,
          variant_id: 32937641865,
        },
        {
          min: 2,
          max: 2,
          btn_text: "Add 1 More",
          link_text: " and get the 4th Kit for Free",
          qty: 1,
          variant_id: 32937641865,
        },
      ],
      29560431433: [
        // {
        //   min: 1,
        //   max: 1,
        //   btn_text: "Add 1 More",
        //   link_text: " and get a Free 7-in-1 Multi-Tool",
        //   qty: 1,
        //   variant_id: 29560431433,
        // },
      ],
      28619651465: [
        {
          min: 1,
          max: 1,
          btn_text: "Add 1 More",
          link_text: " and get a Tact-350 Flashlight Free",
          qty: 1,
          variant_id: 28619651465,
        },
        {
          min: 2,
          max: 2,
          btn_text: "Add 1 More",
          link_text: " and get 2 Tact-350 Flashlight Free",
          qty: 1,
          variant_id: 28619651465,
        },
      ],
      38908526985: [
        {
          min: 1,
          max: 1,
          btn_text: "Add 2 More",
          link_text: " and get a Tact-1200 Kit Free",
          qty: 2,
          variant_id: 38908526985,
        },
        {
          min: 2,
          max: 2,
          btn_text: "Add 1 More",
          link_text: " and get a Tact-1200 Kit Free",
          qty: 1,
          variant_id: 38908526985,
        },
      ],
      32509832265: [
        {
          min: 1,
          max: 1,
          btn_text: "Add 2 More",
          link_text: " and get the 4th Kit for Free",
          qty: 2,
          variant_id: 32509832265,
        },
        {
          min: 2,
          max: 2,
          btn_text: "Add 1 More",
          link_text: " and get the 4th Kit for Free",
          qty: 1,
          variant_id: 32509832265,
        },
      ],
      330498015241: [
        {
          min: 1,
          max: 1,
          btn_text: "Add 1 More",
          link_text: " and get 3rd for Free",
          qty: 1,
          variant_id: 330498015241,
        },
        {
          min: 2,
          max: 2,
          btn_text: "Add 1 More",
          link_text: " and get 2 More for Free",
          qty: 1,
          variant_id: 330498015241,
        },
      ],
      2363547942921: [
        {
          min: 1,
          max: 1,
          btn_text: "Add 1 More",
          link_text: " and get 3rd for Free",
          qty: 1,
          variant_id: 2363547942921,
        },
        {
          min: 2,
          max: 2,
          btn_text: "Add 1 More",
          link_text: " and get 2 More for Free",
          qty: 1,
          variant_id: 2363547942921,
        },
      ],
      45396427401: [
        //         {
        //           min: 1,
        //           max: 1,
        //           btn_text: "Add 2 More",
        //           link_text: " and get a Free Paracord Bracelet",
        //           qty: 2,
        //           variant_id: 45396427401,
        //         },
        //         {
        //           min: 2,
        //           max: 2,
        //           btn_text: "Add 1 More",
        //           link_text: " and get a Free Paracord Bracelet",
        //           qty: 1,
        //           variant_id: 45396427401,
        //         },
      ],
      91715207177: [
        //         {
        //           min: 1,
        //           max: 1,
        //           btn_text: "Add 1 More",
        //           link_text: " and get a Free Paracord Bracelet",
        //           qty: 1,
        //           variant_id: 91715207177,
        //         },
      ],
      1838788411401: [
        {
          min: 1,
          max: 1,
          btn_text: "Add 1 More",
          link_text: " and get 3rd for Free",
          qty: 1,
          variant_id: 1838788411401,
        },
        {
          min: 2,
          max: 2,
          btn_text: "Add 1 More",
          link_text: " and get 2 for Free",
          qty: 1,
          variant_id: 1838788411401,
        },
      ],
      906239279113: [
        {
          min: 1,
          max: 1,
          btn_text: "Add 1 More",
          link_text: " and get 3rd for Free",
          qty: 1,
          variant_id: 906239279113,
        },
        {
          min: 2,
          max: 2,
          btn_text: "Add 1 More",
          link_text: " and get 2 for Free",
          qty: 1,
          variant_id: 906239279113,
        },
      ],
      12336962043998: [
        {
          min: 1,
          max: 1,
          btn_text: "Add 1 More",
          link_text: " Buy 2 Get 1 Free",
          qty: 1,
          variant_id: 12336962043998,
        },
        {
          min: 2,
          max: 2,
          btn_text: "Add 1 More",
          link_text: " Buy 3 Get 2 Free",
          qty: 1,
          variant_id: 12336962043998,
        },
      ],
    },
    getVariantIds: function () {
      return Object.keys(SW.collection.cartRules);
    },
    bonusRules: function () {
      return SW.collection.getVariantIds().reduce(function (acc, variant_id) {
        acc = SW.collection.getBonuses(variant_id).reduce(function (
          acc,
          bonus
        ) {
          acc[bonus.id] = acc[bonus.id] || 0;
          acc[bonus.id] += bonus.qty;
          return acc;
        }, acc);
        return acc;
      }, {});
    },
    cartItems: function () {
      var items = Shopify.cart.items || [];
      return items.reduce(function (acc, i) {
        acc[i.id] = i.quantity;
        return acc;
      }, {});
    },
    upsellCartItems: function () {
      var items = Shopify.cart.items || [];
      return items.reduce(function (acc, i) {
        if (i.price !== 0) {
          acc[i.id] = i.quantity;
        }
        return acc;
      }, {});
    },
    cartMeta: function () {
      var cart = Shopify.cart;
      var data = {
        has_discount: cart.total_discount > 0,
        free_shipping:
          cart.total_price > 9900 ||
          (cart.item_count > 0 && cart.total_weight === 0),
        total_discount: cart.total_discount,
        items: [],
      };

      cart.items.reduce(function (acc, i) {
        acc.push({
          variant_id: i.variant_id,
          price: i.price,
          discounted_price: i.discounted_price,
          has_discount: i.total_discount > 0,
        });
        return acc;
      }, data.items);

      return data;
    },
    setCartItemQuantity: function (variant_id, qty) {
      var cart = Shopify.cart;
      if (!cart.hasOwnProperty("items")) return false;
      cart.items.forEach(function (i, l) {
        if (i.id === variant_id) cart.items[l].quantity = qty;
      });
      return true;
    },
    getCartItemQuantity: function (variant_id) {
      var items = SW.collection.cartItems();
      return items.hasOwnProperty(variant_id) ? items[variant_id] : 0;
    },
    getRules: function (variant_id) {
      var rules = SW.collection.cartRules;
      return rules.hasOwnProperty(variant_id) ? rules[variant_id] : [];
    },
    getBonuses: function (variant_id) {
      return SW.collection
        .getRules(variant_id)
        .map(function (r) {
          return r.bonuses;
        })
        .reduce(function (acc, b) {
          acc = acc.concat(b);
          return acc;
        }, []);
    },
    getOffers: function (variant_id) {
      var offers = SW.collection.cartOffers;
      return offers.hasOwnProperty(variant_id) ? offers[variant_id] : [];
    },
    getMatchingBonuses: function (variant_id, qty) {
      return SW.collection.getRules(variant_id).reduce(
        function (acc, r) {
          var rule_match = qty >= r.min && (!r.max || qty <= r.max);
          if (rule_match) acc.matched = acc.matched.concat(r.bonuses);
          if (!rule_match) acc.missed = acc.missed.concat(r.bonuses);
          return acc;
        },
        { matched: [], missed: [] }
      );
    },
    getMatchingOffers: function (variant_id, qty) {
      return SW.collection.getOffers(variant_id).reduce(function (acc, o) {
        var rule_match = qty >= o.min && (!o.max || qty <= o.max);
        if (rule_match) acc.push(o);
        return acc;
      }, []);
    },
    getCartActions: function () {
      var actions = SW.collection.getVariantIds().reduce(
        function (acc, id) {
          var matched = SW.collection.getMatchingBonuses(
            id,
            SW.collection.getCartItemQuantity(id)
          ).matched;
          acc.mutate = matched.reduce(function (acc, b) {
            acc[b.id] += b.qty;
            return acc;
          }, acc.mutate);
          acc.show[id] = matched.map(function (b) {
            return b.id;
          });
          acc.offers[id] = SW.collection.getMatchingOffers(
            id,
            SW.collection.getCartItemQuantity(id)
          );
          acc.offers_count += acc.offers[id].length > 0;
          return acc;
        },
        {
          mutate: Object.keys(SW.collection.bonusRules()).reduce(function (
            acc,
            id
          ) {
            acc[id] = 0;
            return acc;
          }, {}),
          show: {},
          offers: {},
          offers_count: 0,
        }
      );

      // actions.mutate = jQuery.extend(SW.collection.cartItems(), actions.mutate);
      actions.mutate = jQuery.extend(SW.collection.cartItems(), {});

      return actions;
    },
    createOffer: function (offer, container, id) {
      var template = $("#cart-upsell-template");
      if (!template.length) return "";
      template = $(template.clone().get(0));
      template.attr("id", null);
      template.children("a").attr("data-variant-id", offer.variant_id);
      template.children("a").attr("data-quantity", offer.qty);
      template
        .children("a")
        .attr(
          "onclick",
          "SW.collection.updateCartAdd(" +
            offer.variant_id +
            "," +
            offer.qty +
            "); return false;"
        );
      template.find("a.bonus-btn span").html(offer.btn_text);
      template.find("a.bonus-text span").html(offer.link_text);
      template.appendTo(container).show();
      return template;
    },
    createOffersForItem: function (variant_id, offers, show_banner) {
      show_banner = show_banner || false;
      var container = $(
        '<tr class="cart-item-offer" style="padding:1px;"></tr>'
      ).attr({ id: "b-" + variant_id });
      var el = $(
        '<div style="background:#fbfbfb;padding:2px 2px;border-radius:5px;" class="cart-upsell-container"></div>'
      );

      if (show_banner) {
        var banner = $("#cart-upsell-template-banner");
        if (banner.length) {
          banner = $(banner.clone().get(0)).attr("id", null);
          el.append(banner);
        }
      }

      offers.forEach(function (o) {
        SW.collection.createOffer(o, el, variant_id);
      });

      $("#v-" + variant_id).after(
        container.append(
          $('<td colspan="5" style="padding:3px;"></td>').append(el)
        )
      );
      return container;
    },
    updateCartAdd: function (variant_id, qty) {
      qty = +qty;
      if (qty > 0) {
        var new_qty = SW.collection.getCartItemQuantity(variant_id) + qty;
        var input = $("#updates_" + variant_id);
        if (input.length) input.val(new_qty);
        SW.collection.setCartItemQuantity(variant_id, new_qty);
      }
      SW.collection.evalCart();
      return true;
    },
    updateCart: function (variant_id, qty) {
      qty = +qty;
      if (qty > 0) {
        SW.collection.setCartItemQuantity(variant_id, qty);
      }
      SW.collection.evalCart();
      return true;
    },
    removeCartItem: function (variant_id) {
      SW.collection.setCartItemQuantity(variant_id, 0);
      SW.collection.evalCart();
      return true;
    },
    displayCartOffers: function (actions) {
      $(".cart-item-offer").remove();
      $.each(actions.offers, function (id, offers) {
        if (offers.length) {
          var show_banner = actions.offers_count === 1;
          SW.collection.createOffersForItem(id, offers, show_banner);
        }
      });
    },
    displayCartBonuses: function (actions) {
      $(".bonus-cart-item").hide();
      $.each(actions.show, function (id, bonuses) {
        bonuses.forEach(function (bonus_id) {
          var bonus_item = jQuery("#v-" + bonus_id);
          if (bonus_item.length) {
            var bonus_qty = actions.mutate[bonus_id] || 0;
            bonus_item.find(".bonus-cart-item-qty").html(bonus_qty);
            bonus_item.show();
          }
        });
      });
    },
    refreshCartStats: function (cart, on_cart_page) {
      if (on_cart_page) {
        var meta = SW.collection.cartMeta();

        if (meta.free_shipping) {
          $("#summary-free-shipping")
            .removeClass("hide_fs")
            .addClass("show_fs");
        } else {
          $("#summary-free-shipping")
            .removeClass("show_fs")
            .addClass("hide_fs");
        }

        if (meta.has_discount) {
          $("#summary-discounts span.money").html(
            SW.currency.formatMoney(meta.total_discount * -1, true)
          );
          $("#summary-discounts").removeClass("hide_fs").addClass("show_fs");
        } else {
          $("#summary-discounts").removeClass("show_fs").addClass("hide_fs");
        }

        meta.items.forEach(function (item) {
          var el = $("#v-" + item.variant_id + " span.price");
          if (item.has_discount) {
            el.addClass("price-discount").html(
              SW.currency.formatMoney(item.discounted_price, true)
            );
          } else {
            el.removeClass("price-discount").html(
              SW.currency.formatMoney(item.price, true)
            );
          }
        });

        $("span.cart-qty").html(cart.item_count);
        if ($("#cart-sub-total").length) {
          $("#cart-sub-total").html(
            SW.currency.formatMoney(cart.original_total_price, true)
          );
          $("#cart-grand-total").html(
            SW.currency.formatMoney(cart.total_price, true)
          );
        }
      } else {
        SW.collection.updateCartInfo(
          cart,
          ".cart-container .cart-wrapper .cart-inner-content"
        );
      }
    },
    evalCart: function (target_id) {
      var queue = ASQ();
      var actions = SW.collection.getCartActions();
      var on_cart_page = $("#cart-form").length;

      $(".cartloading").show();
      $("#resultLoading").show();

      if (on_cart_page) {
        // SW.collection.displayCartOffers(actions);
        // SW.collection.displayCartBonuses(actions);
      }

      queue
        .then(function (done) {
          Shopify.updateCartItems(actions.mutate, function (r) {
            Shopify.cart = r;
            done();
          });
        })
        .after(100);

      // queue
      //   .then(function (done) {
      //     var cart = Shopify.cart;
      //     var cartMeta = SW.collection.cartMeta();
      //     var free_product_variant_id = "1365342683145";
      //     var hasFreeGift = cart.items.some(
      //       (item) =>
      //         item.variant_id == free_product_variant_id &&
      //         item.properties._free_gift == "1"
      //     );
      //     var discountedTotal = cart.items.reduce((acc, item) => {
      //       if (
      //         item.variant_id != free_product_variant_id &&
      //         item.properties._free_gift !== "1"
      //       ) {
      //         acc += item.quantity * item.discounted_price;
      //       }
      //       return acc;
      //     }, 0);

      //     if (discountedTotal >= 9900 && !hasFreeGift) {
      //       SW.collection.addFreeProduct(free_product_variant_id, done);
      //     } else if (discountedTotal < 9900 && hasFreeGift) {
      //       SW.collection.removeFreeProduct(free_product_variant_id, done);
      //     } else {
      //       done();
      //     }
      //   })
      //   .after(100);

      queue.then(function (done) {
        SW.collection.refreshCartStats(Shopify.cart, on_cart_page);
        // SW.collection.handleEUCart();
        // SW.collection.handleUpsellCart();
        done();
      });

      queue.val(function () {
        jQuery("form#cart-form").off("submit", false);
        if (target_id) {
          if (target_id === "form#cart-form") {
            $(target_id).submit();
          } else {
            $(target_id).click();
          }
        } else {
          $(".cartloading").hide();
          $("#resultLoading").hide();
        }
      });
    },
    removeFreeProduct(variant_id, done) {
      fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({
          id: variant_id,
          quantity: 0,
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          // console.log("Free product removed:", data);
          if (jQuery("#cart-form").length) {
            setTimeout(function () {
              location.reload();
            }, 200);
          }
          done();
        })
        .catch((error) => {
          console.error("Error removing free product:", error);
          done();
        });
    },
    addFreeProduct(variant_id, done) {
      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({
          id: variant_id,
          quantity: 1,
          properties: {
            _free_gift: "1",
          },
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          // console.log("Free product added:", data);
          if (jQuery("#cart-form").length) {
            setTimeout(function () {
              location.reload();
            }, 200);
          }
          done();
        })
        .catch((error) => {
          console.error("Error adding free product:", error);
          done();
        });
    },
    refreshMiniCart() {
      Shopify.getCart(function (data) {
        SW.collection.updateCartInfo(
          data,
          ".cart-container .cart-wrapper .cart-inner-content"
        );
      });
    },
    addToCart2: function () {
      $(document).on("click", ".add-item-to-cart", function (e) {
        e.preventDefault();
        var variantID = $(this).data("variant-id");
        var quantity = $(this).data("quantity");
        return $.ajax({
          type: "POST",
          url: "/cart/add.js",
          async: !0,
          data: { id: variantID, quantity: quantity },
          dataType: "json",
          beforeSend: function () {
            $("#resultLoading").show();
          },
          error: function (t) {
            var box = $("#error-notice"),
              i = $.parseJSON(t.responseText);
            box.find(".heading").html(i.message);
            box.find(".message").html(i.description);
            setTimeout(function () {
              $(".loader-container").hide();
              $("#resultLoading").hide();
              box.addClass("show");
              setTimeout(function () {
                box.removeClass("show");
              }, 5e3);
            }, 500);
          },
          success: function (t) {
            Shopify.getCart(function (e) {
              box = $("#cart-box");
              box.find(".product-link").attr("href", t.url),
                box
                  .find(".product-img")
                  .attr("src", Shopify.resizeImage(t.image, "medium"))
                  .attr("alt", SW.page.translateText(t.title)),
                box
                  .find(".product-title .product-link")
                  .html(SW.page.translateText(t.title)),
                box
                  .find(".product-price")
                  .html(Shopify.formatMoney(t.price, money_format)),
                frontendData.enableCurrency &&
                  currenciesCallbackSpecial("#cart-box span.money");
              setTimeout(function () {
                $(".loader-container").hide();
                $("#resultLoading").hide();
                location.reload();
              }, 500),
                SW.collection.updateCartInfo(
                  e,
                  ".cart-container .cart-wrapper .cart-inner-content"
                );
            });
            return false;
          },
          cache: !1,
        });
      });
    },
    addToCart3: function () {
      $(document).on("click", ".add-item-to-cart-go", function (e) {
        e.preventDefault();
        var variantID = $(this).data("variant-id");
        var quantity = $(this).data("quantity");
        return $.ajax({
          type: "POST",
          url: "/cart/add.js",
          async: !0,
          data: { id: variantID, quantity: quantity },
          dataType: "json",
          beforeSend: function () {
            $("#resultLoading").show();
          },
          error: function (t) {
            var box = $("#error-notice"),
              i = $.parseJSON(t.responseText);
            box.find(".heading").html(i.message);
            box.find(".message").html(i.description);
            setTimeout(function () {
              $(".loader-container").hide();
              $("#resultLoading").hide();
              box.addClass("show");
              setTimeout(function () {
                box.removeClass("show");
              }, 5e3);
            }, 500);
          },
          success: function (t) {
            Shopify.getCart(function (e) {
              box = $("#cart-box");
              box.find(".product-link").attr("href", t.url),
                box
                  .find(".product-img")
                  .attr("src", Shopify.resizeImage(t.image, "medium"))
                  .attr("alt", SW.page.translateText(t.title)),
                box
                  .find(".product-title .product-link")
                  .html(SW.page.translateText(t.title)),
                box
                  .find(".product-price")
                  .html(Shopify.formatMoney(t.price, money_format)),
                frontendData.enableCurrency &&
                  currenciesCallbackSpecial("#cart-box span.money");
              setTimeout(function () {
                $(".loader-container").hide();
                $("#resultLoading").hide();
                //                 location.reload();
                window.location.href = "/cart";
              }, 500),
                SW.collection.updateCartInfo(
                  e,
                  ".cart-container .cart-wrapper .cart-inner-content"
                );
            });
            return false;
          },
          cache: !1,
        });
      });
    },
    updateCartInfo: function (cart, e) {
      if (cart.item_count === 0) {
        $(".b-checkout").removeClass("show");
      } else {
        $(".b-checkout").addClass("show");
        $(".sticky-product").remove();
        $("#back-top").remove();
      }
      $(".floating-qty").text(cart.item_count).html();
      var c = $(e);
      var t = $(".icon-cart-header .price");
      var d = $(".icon-cart-header .cart-total");
      if (c.length) {
        c.empty();
        t.empty();
        $.each(cart, function (key, value) {
          if (key == "items") {
            var $html = "";
            if (value.length) {
              // t.html(Shopify.formatMoney(cart.total_price, money_format));
              t.html(SW.currency.formatMoney(cart.total_price, true));
              d.html(
                '<span class="cart-qty">' +
                  cart.item_count +
                  "</span><span>" +
                  cartData.totalNumb +
                  "</span>"
              );
              $html += '<div class="cart-content">';
              $html += '<ul class="clearfix">';
              $.each(value, function (i, item) {
                $html += '<li class="item-cart">';
                $html +=
                  '<a class="product-image" href="' +
                  item.url +
                  '"><img alt="' +
                  SW.page.translateText(item.title) +
                  '" src="' +
                  Shopify.resizeImage(item.image, "small") +
                  '" /></a>';
                $html += '<div class="product-details row-fluid show-grid">';
                $html +=
                  '<p class="product-name"><a href="' +
                  item.url +
                  '"><span>' +
                  SW.page.translateText(item.title) +
                  "</span></a></p>";
                // $html += '<div class="items"><span class="price">'+item.quantity+' × <span class="amount">'+ Shopify.formatMoney(item.price, money_format) +'</span></span></div>';
                $html +=
                  '<div class="items"><span class="price">' +
                  item.quantity +
                  ' × <span class="amount">' +
                  SW.currency.formatMoney(item.price, true) +
                  "</span></span></div>";
                if (item.product_type !== "Bonus") {
                  $html +=
                    '<div class="access"><a href="javascript: void(0);" class="btn-remove btn-remove-cart" data-id="' +
                    item.variant_id +
                    '" title="' +
                    cartData.removeItemLabel +
                    '"><i class="icon-cancel"></i></a></div>';
                }
                $html += "</div>";
                $html += "</li>";
              });
              $html += "</ul>";
              $html += "</div>";
              $html += '<div class="cart-checkout">';
              // $html += '<div class="cart-info"><p class="subtotal"><span class="label">'+cartData.totalLabel+'</span><span class="price">'+Shopify.formatMoney(cart.total_price, money_format)+'</span></p></div>';
              $html +=
                '<div class="cart-info"><p class="subtotal"><span class="label">' +
                cartData.totalLabel +
                '</span><span class="price">' +
                SW.currency.formatMoney(cart.total_price, true) +
                "</span></p></div>";
              $html += '<div class="actions">';
              $html +=
                '<a href="/cart" class="btn-button view-cart bordered uppercase"><span>' +
                cartData.buttonViewCart +
                "</span></a> ";
              //                 $html += '<a href="/checkout" class="btn-button checkout-cart bordered uppercase"><span>'+cartData.buttonCheckout+'</span></a>';
              $html += "</div>";
              $html += "</div>";
            } else {
              // t.html(Shopify.formatMoney(cart.total_price, money_format));
              t.html(SW.currency.formatMoney(cart.total_price, true));
              d.html(
                '<span class="cart-qty">' +
                  cart.item_count +
                  "</span><span>" +
                  cartData.totalNumb +
                  "</span>"
              );
              $html += '<div class="cart-content">';
              $html +=
                '<p class="no-items-in-cart">' + cartData.noItemLabel + "</p>";
              $html += "</div>";
            }
          }
          c.append($html);
          if ($("#cart-sub-total").length) {
            // $('#cart-sub-total').html( Shopify.formatMoney( cart.original_total_price ), money_format );
            // $('#cart-grand-total').html( Shopify.formatMoney( cart.total_price ), money_format );
            $("#cart-sub-total").html(
              SW.currency.formatMoney(cart.original_total_price, true)
            );
            $("#cart-grand-total").html(
              SW.currency.formatMoney(cart.total_price, true)
            );
          }
        });
      }
      if ($(".icon-cart-header .cart-count").length > 0) {
        $(".icon-cart-header .cart-count").html(cart.item_count);
      }
      if (frontendData.enableCurrency) {
        currenciesCallbackSpecial(".cart-wrapper .cart-inner span.money");
        currenciesCallbackSpecial(".icon-cart-header span.money");
      }
    },
    removeCartInit: function (id, r) {
      $.ajax({
        type: "POST",
        url: "/cart/change.js",
        data: "quantity=0&id=" + id,
        dataType: "json",
        beforeSend: function () {
          $(".cartloading").show();
        },
        success: function (t) {
          if (typeof r === "function") {
            r(t);
          } else {
            SW.collection.updateCartInfo(
              t,
              ".cart-container .cart-wrapper .cart-inner-content"
            );
            $(".cartloading").hide();
            if (jQuery("#cart-form").length) {
              setTimeout(function () {
                location.reload();
              }, 200);
            }
          }
        },
        error: function (XMLHttpRequest, textStatus) {
          Shopify.onError(XMLHttpRequest, textStatus);
        },
      });
    },
    sidebarMenuInit: function () {
      $("#mobile-menu, #categories_nav").mobileMenu({
        accordion: true,
        speed: 400,
        closedSign: "collapse",
        openedSign: "expand",
        mouseType: 0,
        easing: "easeInOutQuad",
      });
    },
    sortbyFilter: function () {
      $(document).on("change", ".sort-by .field", function (e) {
        e.preventDefault();
        var t = $(this),
          i = t.val();
        Shopify.queryParams.sort_by = i;
        SW.collection.filterAjaxRequest();
      });
    },
    limitedAsFilter: function () {
      $(document).on("change", ".limited-view .field", function (e) {
        e.preventDefault();
        var t = $(this),
          i = t.val();
        Shopify.queryParams.view = i;
        SW.collection.filterAjaxRequest();
      });
    },
    swatchListFilter: function () {
      $(document).on(
        "click",
        ".narrow-by-list .item:not(.disable), .advanced-filter .field:not(.disable)",
        function () {
          var e = $(this),
            t = e.find("input").val(),
            i = [];
          if (
            (Shopify.queryParams.constraint &&
              (i = Shopify.queryParams.constraint.split("+")),
            !e.hasClass("active"))
          ) {
            var a = e
              .parents(".layer-filter, .advanced-filter")
              .find(".active");
            a.length > 0 &&
              a.each(function () {
                var e = $(this).data("handle");
                if (($(this).removeClass("active"), e)) {
                  var t = i.indexOf(e);
                  t >= 0 && i.splice(t, 1);
                }
              });
          }
          if (t) {
            var o = i.indexOf(t);
            0 > o
              ? (i.push(t), e.addClass("active"))
              : (i.splice(o, 1), e.removeClass("active"));
          }
          i.length
            ? (Shopify.queryParams.constraint = i.join("+"))
            : delete Shopify.queryParams.constraint,
            SW.collection.filterAjaxRequest();
        }
      );
    },
    paginationActionInit: function () {
      $(document).on("click", ".pagination-page a", function (e) {
        var page = $(this)
          .attr("href")
          .match(/page=\d+/g);
        if (page) {
          Shopify.queryParams.page = parseInt(page[0].match(/\d+/g));
          if (Shopify.queryParams.page) {
            var newurl = SW.collection.filterCreateUrl();
            History.pushState(
              {
                param: Shopify.queryParams,
              },
              newurl,
              newurl
            );
            SW.collection.filterGetContent(newurl);
          }
        }
        e.preventDefault();
      });
    },
    layerFilterInit: function () {
      SW.collection.sortbyFilter();
      SW.collection.limitedAsFilter();
      SW.collection.paginationActionInit();
      SW.collection.swatchListFilter();
      SW.collection.layerClearAllFilter();
      SW.collection.layerClearFilter();
    },
    filterCreateUrl: function (baseLink) {
      var newQuery = $.param(Shopify.queryParams).replace(/%2B/g, "+");
      if (baseLink) {
        //location.href = baseLink + "?" + newQuery;
        if (newQuery != "") return baseLink + "?" + newQuery;
        else return baseLink;
      }
      return location.pathname + "?" + newQuery;
    },
    filterAjaxRequest: function (baseLink) {
      delete Shopify.queryParams.page;
      var newurl = SW.collection.filterCreateUrl(baseLink);
      History.pushState(
        {
          param: Shopify.queryParams,
        },
        newurl,
        newurl
      );
      SW.collection.filterGetContent(newurl);
    },
    filterGetContent: function (e) {
      $.ajax({
        type: "get",
        url: e,
        beforeSend: function () {
          $("#resultLoading").show();
        },
        success: function (t) {
          infinite_loaded_count = 0;
          var i = t.match("<title>(.*?)</title>");
          i = i ? i[1] : document.title;
          $("#collection-main")
            .empty()
            .html($(t).find("#collection-main").html()),
            $(".narrow-by-list")
              .empty()
              .html($(t).find(".narrow-by-list").html()),
            $(".pagination").empty().html($(t).find(".pagination").html()),
            $(".main-breadcrumbs")
              .empty()
              .html($(t).find(".main-breadcrumbs").html()),
            History.pushState(
              {
                param: Shopify.queryParams,
              },
              i,
              e
            ),
            setTimeout(function () {
              $("html,body").animate(
                {
                  scrollTop: $(".toolbar").offset().top,
                },
                500
              );
            }, 100);
          $("#resultLoading").hide();
          if (SW.collection.readCookie("products-listmode") != null) {
            SW.collection.layoutListInit();
          }
          SW.collection.productGridSetup();
          SW.collection.layerClearFilter();
          SW.collection.layerClearAllFilter();
          SW.collection.colorSwatchGridInit();
          SW.page.setVisualState();
          SW.collection.initInfiniteScrolling();
          SW.page.setSelect();
          SW.collection.sidebarInitToggle();
          SW.page.translateBlock(".main-wrapper");
          if ($(".spr-badge").length > 0) {
            SPR.registerCallbacks();
            SPR.initRatingHandler();
            SPR.initDomEls();
            SPR.loadProducts();
            SPR.loadBadges();
          }
          frontendData.enableCurrency &&
            currenciesCallbackSpecial(".products-grid span.money");
          SW.currency.convertCurrency();
          if (typeof StampedFn !== "undefined") StampedFn.loadBadges();
        },
        error: function () {
          $("#resultLoading").hide();
        },
      });
    },
    sidebarInitToggle: function () {
      if ($(".sidebar-toogle").length > 0) {
        $(".sidebar-toogle .block-title span.collapse").click(function () {
          if ($(this).hasClass("click")) {
            $(this).removeClass("click");
            $(this).parent().removeClass("closed");
          } else {
            $(this).parent().addClass("closed");
            $(this).addClass("click");
          }
          $(this)
            .parents(".sidebar-toogle")
            .find(".sidebar-content")
            .slideToggle();
        });
      }
    },
    sidebarCategoryInitToggle: function () {
      if ($(".sidebar-cate-toogle").length > 0) {
        $(".sidebar-cate-toogle .block-title span.collapse").click(function () {
          if ($(this).hasClass("click")) {
            $(this).removeClass("click");
            $(this).parent().removeClass("closed");
          } else {
            $(this).parent().addClass("closed");
            $(this).addClass("click");
          }
          $(this)
            .parents(".sidebar-cate-toogle")
            .find(".sidebar-content")
            .slideToggle();
        });
      }
    },
    layerClearFilter: function () {
      $(".narrow-by-list .narrow-item").each(function () {
        var e = $(this);
        e.find("input:checked").length > 0 &&
          e.find(".clear").click(function (t) {
            var i = [];
            Shopify.queryParams.constraint &&
              (i = Shopify.queryParams.constraint.split("+")),
              e.find("input:checked").each(function () {
                var e = jQuery(this),
                  t = e.val();
                if (t) {
                  var a = i.indexOf(t);
                  a >= 0 && i.splice(a, 1);
                }
              }),
              i.length
                ? (Shopify.queryParams.constraint = i.join("+"))
                : delete Shopify.queryParams.constraint,
              SW.collection.filterAjaxRequest(),
              t.preventDefault();
          });
      });
    },
    layerClearAllFilter: function () {
      $(document).on(
        "click",
        ".narrow-by-list .clearall, .filter-option-inner .clearall",
        function (e) {
          e.preventDefault();
          delete Shopify.queryParams.constraint,
            delete Shopify.queryParams.q,
            SW.collection.filterAjaxRequest();
        }
      );
    },
    tabInfinityScrollInit: function () {
      var $maintab = $(".tab-content .category-products"),
        $limit = $maintab.find(".data-tab").data("limit"),
        $show = $maintab.find(".data-tab").data("show"),
        $text = $maintab.find(".data-tab").data("text"),
        $translate = $maintab.find(".data-tab").data("translate"),
        $total = $maintab.find(".products-grid .item").length;
      if (!$maintab.find(".data-tab").data("showmore")) return;

      for (i = 0; i <= $total; i++) {
        if (i > $show) {
        }
      }
      if ($total > $limit) {
        $mainsc = $("<div/>").addClass(
          "infinite-scrolling-homepage wow fadeIn"
        );
        $in = $("<span/>")
          .addClass("sc-show-more")
          .attr("data-translate", $translate)
          .text($text)
          .appendTo($mainsc);
        $maintab.append($mainsc);
      }
    },
    countDowntInit: function () {
      $(".product-date").each(function (i, item) {
        var date = $(item).attr("data-date");
        var countdown = {
          yearText: window.date_text.year_text,
          monthText: window.date_text.month_text,
          weekText: window.date_text.week_text,
          dayText: window.date_text.day_text,
          hourText: window.date_text.hour_text,
          minText: window.date_text.min_text,
          secText: window.date_text.sec_text,
          yearSingularText: window.date_text.year_singular_text,
          monthSingularText: window.date_text.month_singular_text,
          weekSingularText: window.date_text.week_singular_text,
          daySingularText: window.date_text.day_singular_text,
          hourSingularText: window.date_text.hour_singular_text,
          minSingularText: window.date_text.min_singular_text,
          secSingularText: window.date_text.sec_singular_text,
        };
        var template =
          '<div class="day"><span class="no">%d</span><span class="text">%td</span></div><div class="hours"><span class="no">%h</span><span class="text">%th</span></div><div class="min"><span class="no">%i</span><span class="text">%ti</span></div><div class="second"><span class="no">%s</span><span class="text">%ts</span></div>';
        if (date) {
          var config = { date: date };
          $.extend(config, countdown);
          if (template) {
            config.template = template;
          }
          $(item).countdown(config);
        }
      });
    },
    initInfiniteScrolling: function () {
      $(window).scroll(function () {
        if (
          $(".infinite-loader").length > 0 &&
          $(window).scrollTop() >=
            $(".infinite-loader").offset().top - $(window).height() + 100
        ) {
          if (infinite_loaded_count < 2) {
            $(".infinite-loader a").trigger("click");
          }
        }
      });
      if ($(".infinite-loader").length > 0) {
        $(".infinite-loader a").click(function (e) {
          e.preventDefault();
          if (!$(this).hasClass("disabled")) {
            SW.collection.doInfiniteScrolling();
          }
        });
      }
    },
    doInfiniteScrolling: function () {
      var currentList = $("#collection-main .products-grid");
      var products = $("#products-grid");
      infinite_loaded_count = infinite_loaded_count + 1;
      if (currentList) {
        var showMoreButton = $(".infinite-loader a").first();
        $.ajax({
          type: "GET",
          url: showMoreButton.attr("href"),
          beforeSend: function () {
            $(".infinite-loader .btn-load-more").hide();
            $(".infinite-loader .loading").fadeIn(300);
          },
          success: function (data) {
            loading = false;
            var items = $(data).find("#collection-main .products-grid .item");
            if (items.length > 0) {
              products.append(items);
              SW.page.translateBlock("." + currentList.attr("class"));

              //get link of Show more
              if ($(data).find(".infinite-loader").length > 0) {
                showMoreButton.attr(
                  "href",
                  $(data).find(".infinite-loader a").attr("href")
                );
                if (infinite_loaded_count >= 2) {
                  $(".infinite-loader .loading").fadeOut(300);
                  $(".infinite-loader .btn-load-more").show();
                } else {
                  $(".infinite-loader .loading").fadeOut(300);
                }
              } else {
                //no more products
                $(".infinite-loader .loading").fadeOut(300);
                showMoreButton.hide();
              }

              if (SW.collection.readCookie("products-listmode") != null) {
                SW.collection.layoutListInit();
              }
              SW.collection.productGridSetup();
              SW.collection.layerClearFilter();
              SW.collection.layerClearAllFilter();
              //               SW.collection.colorSwatchGridInit();
              SW.page.setVisualState();
              frontendData.enableCurrency &&
                currenciesCallbackSpecial(".products-grid span.money");
              if ($(".spr-badge").length > 0) {
                SPR.registerCallbacks();
                SPR.initRatingHandler();
                SPR.initDomEls();
                SPR.loadProducts();
                SPR.loadBadges();
              }
            }
          },
          error: function (xhr, text) {
            $(".infinite-loader .btn-load-more").hide();
            $(".infinite-loader .loading").fadeOut(300);
          },
          dataType: "html",
        });
      }
    },
  };
  SW.productMediaManager = {
    destroyZoom: function () {
      $(".zoomContainer").remove();
      $(".product-image-gallery .gallery-image").removeData("elevateZoom");
    },
    init: function () {
      if (dataZoom.position == "inside") {
        var zoomConfig = {
          gallery: "more-slides",
          zoomType: "inner",
          cursor: "pointer",
          scrollZoom: true,
        };
      } else {
        var zoomConfig = {
          gallery: "more-slides",
          cursor: "pointer",
          scrollZoom: false,
          zoomWindowFadeIn: 500,
          zoomWindowFadeOut: 500,
          lensFadeIn: 500,
          lensFadeOut: 500,
          borderSize: 1,
          lensBorderSize: 1,
          lensBorderColour: "#999",
          borderColour: "#ddd",
          touchEnabled: false,
        };
      }
      var zoomImage = $("#product-featured-image");
      var imageGallery = $(".product-image-gallery");
      imageGallery.addClass("loading");
      imagesLoaded(zoomImage, function () {
        zoomImage.ezPlus(zoomConfig);
        imageGallery.removeClass("loading");
      });
      $(document).on("click", "#more-slides a", function () {
        $(".zoomContainer").remove();
        zoomImage.removeData("elevateZoom");
        zoomImage.attr("src", $(this).data("image"));
        zoomImage.data("zoom-image", $(this).data("zoom-image"));
        imageGallery.addClass("loading");
        imagesLoaded(zoomImage, function () {
          zoomImage.ezPlus(zoomConfig);
          imageGallery.removeClass("loading");
        });
      });
      if (dataZoom.lightbox) {
        $("#product-featured-image").bind("click", function (e) {
          var ez = $("#product-featured-image").data("elevateZoom");
          $.fancybox(ez.getGalleryList());
          return false;
        });
      }
    },
  };
  SW.verticleScroll = {
    init: function () {
      if ($(".product-img-box .verticl-carousel").length > 0) {
        var carousel = $(".product-img-box .verticl-carousel");
        SW.verticleScroll.carouselInit(carousel);
      }
    },
    carouselInit: function (carousel) {
      var count = carousel.find("a").length;
      if (count <= 3) {
        carousel.parents(".more-views-verticle").find(".more-views-nav").hide();
      }
      $(".product-img-box #carousel-up").on("click", function () {
        if (!$(".product-img-box .verticl-carousel").is(":animated")) {
          var bottom = $(".product-img-box .verticl-carousel > a:last-child");
          var clone = $(
            ".product-img-box .verticl-carousel > a:last-child"
          ).clone();
          clone.prependTo(".product-img-box .verticl-carousel");
          $(".product-img-box .verticl-carousel")
            .animate(
              {
                top: "-=85",
              },
              0
            )
            .stop()
            .animate(
              {
                top: "+=85",
              },
              250,
              function () {
                bottom.remove();
              }
            );
          SW.productMediaManager.init();
        }
      });
      $(".product-img-box #carousel-down").on("click", function () {
        if (!$(".product-img-box .verticl-carousel").is(":animated")) {
          var top = $(".product-img-box .verticl-carousel > a:first-child");
          var clone = $(
            ".product-img-box .verticl-carousel > a:first-child"
          ).clone();
          clone.appendTo(".product-img-box .verticl-carousel");
          $(".product-img-box .verticl-carousel").animate(
            {
              top: "-=85",
            },
            250,
            function () {
              top.remove();
              $(".product-img-box .verticl-carousel").animate(
                {
                  top: "+=85",
                },
                0
              );
            }
          );
          SW.productMediaManager.init();
        }
      });
    },
  };
  SW.footer = {
    init: function () {
      SW.footer.backToTopInit();
    },
    backToTopInit: function () {
      $(window).scroll(function () {
        if ($(this).scrollTop() > 100) {
          $("#back-top").fadeIn();
        } else {
          $("#back-top").fadeOut();
        }
      });
      $("#back-top a").click(function () {
        $("body,html").animate(
          {
            scrollTop: 0,
          },
          800
        );
        return false;
      });
    },
  };
  SW.currency = {
    getGeoCountry: function () {
      return jQuery.ajax({
        url: "//api.ipstack.com/check?access_key=069d9d5bed211223ec26e9d4f5f7ceba",
        dataType: "jsonp",
      });
    },
    currencyMap: {
      AT: "EUR",
      AU: "AUD",
      BE: "EUR",
      BG: "BGN",
      CA: "CAD",
      CH: "CHF",
      CY: "EUR",
      CZ: "CZK",
      GB: "GBP",
      DE: "EUR",
      DK: "DKK",
      EE: "EUR",
      ES: "EUR",
      FI: "EUR",
      FR: "EUR",
      GR: "EUR",
      HR: "HRK",
      HU: "HUF",
      IE: "EUR",
      IS: "ISK",
      IT: "EUR",
      LI: "CHF",
      LT: "EUR",
      LU: "EUR",
      LV: "EUR",
      NL: "EUR",
      NO: "NOK",
      MT: "EUR",
      PL: "PLN",
      PT: "EUR",
      RO: "RON",
      SE: "SEK",
      SG: "SGD",
      SI: "EUR",
      SK: "EUR",
      MY: "MYR",
      NZ: "NZD",
      US: "USD",
      BR: "BRL",
      AR: "ARS",
      AE: "AED",
      QA: "QAR",
      SA: "SAR",
      BH: "BHD",
      KW: "KWD",
      OM: "OMR",
      MX: "MXN",
    },
    getCurrencyCode: function (country_code) {
      if (this.currencyMap.hasOwnProperty(country_code)) {
        return this.currencyMap[country_code];
      }
      return "USD";
    },
    locale: {
      loaded: false,
      country_code: "US",
      currency_code: "USD",
      country_name: "United States",
    },
    testLocale: function (country_code) {
      var locale = this.locale;
      locale.country_code = country_code;
      locale.currency_code = SW.currency.getCurrencyCode(country_code);
      this.setLocaleCache(locale);
      return this.convertCurrency();
    },
    fetchLocale: function () {
      var deferred = jQuery.Deferred();
      this.getGeoCountry().done(function (geo) {
        deferred.resolve({
          country_code: geo.country_code,
          currency_code: SW.currency.getCurrencyCode(geo.country_code),
          country_name: geo.country_name,
        });
      });
      return deferred.promise();
    },
    setLocale: function (locale) {
      if (locale && locale.hasOwnProperty("currency_code")) {
        locale.loaded = true;
        this.locale = locale;
      }
      return this.locale;
    },
    getLocaleCache: function () {
      var locale = JSON.parse(jQuery.cookie("sas_locale"));
      return this.setLocale(locale);
    },
    setLocaleCache: function (locale) {
      this.setLocale(locale);
      return jQuery.cookie("sas_locale", JSON.stringify(locale), {
        expires: 365,
        path: "/",
        domain: window.location.hostname,
      });
    },
    getLocale: function () {
      if (this.locale.loaded || this.getLocaleCache().loaded)
        return jQuery.Deferred().resolve(this.locale);
      return this.fetchLocale().then(function (locale) {
        SW.currency.setLocaleCache(locale);
        return jQuery.Deferred().resolve(locale);
      });
    },
    convertCurrency: function () {
      this.getLocale().done(function (locale) {
        if (locale.currency_code !== "USD") {
          SW.currency.replaceCurrency(
            "USD",
            locale.currency_code,
            ".sas-money"
          );
          SW.currency.addGeoMods(locale);
        }
      });
    },
    addGeoMods: function (locale) {
      var geo = locale.country_code.toLowerCase();
      if (locale.country_code !== "US") {
        if ($("#currency-message").length > 0) {
          $("#currency-message").css("display", "block");
          $("#currency-message .currency-message-code").text(
            "(" + locale.currency_code + ")"
          );
        }
        if ($(".hf").length === 0) {
          $(".logo img").after(
            '<img src="//cdn.shopify.com/s/files/1/1660/4869/files/blank.gif?5118501452750714565" class="hf flag flag-' +
              geo +
              '" alt="' +
              locale.country_name +
              '" style="margin-left:3px;position:absolute;width:16px;top:3px;"/>'
          );
        }
        if ($(".shipped-from").length > 0) {
          $(".shipped-from").html(
            '<span style="font-size:16px;"><img src="//cdn.shopify.com/s/files/1/1660/4869/files/blank.gif?5118501452750714565" class="flag flag-' +
              geo +
              '" alt="' +
              locale.country_name +
              '" /> Ships To ' +
              locale.country_name +
              ' <img src="//cdn.shopify.com/s/files/1/1660/4869/t/7/assets/blank.gif?9050536408672531665" class="flag flag-' +
              geo +
              '" alt="' +
              locale.country_name +
              '" /></span>'
          );
          $(".bestseller-text").append(
            '<img src="//cdn.shopify.com/s/files/1/1660/4869/files/blank.gif?5118501452750714565" class="flag flag-' +
              geo +
              '" alt="' +
              locale.country_name +
              '" style="margin-left:3px;width:16px;top:3px;"/>'
          );
        }
      }
    },
    formatMoney: function (amount, with_code) {
      with_code = with_code || false;
      var oldFormat = Currency.money_format["USD"] || "";
      var newFormat = Currency.money_format[this.locale.currency_code] || "";
      var money = Currency.convert(amount, "USD", this.locale.currency_code);
      var formatted = Currency.formatMoney(money, newFormat);
      if (with_code && this.locale.currency_code !== "USD") {
        formatted +=
          '<span class="currency_code">' +
          this.locale.currency_code +
          "</span>";
      }
      return formatted;
    },
    replaceCurrency: function (from, to, selector) {
      jQuery(selector || "span.money").each(function () {
        // If the amount has already been converted, we leave it alone.
        if (jQuery(this).attr("data-currency") === to) return;

        var cents = 0.0;
        var oldFormat = Currency.money_format[from] || "";
        var newFormat = Currency.money_format[to] || "";

        var price = parseInt(
          jQuery(this)
            .html()
            .replace(/[^0-9]/g, ""),
          10
        );

        if (!isNaN(price)) {
          if (oldFormat.indexOf("amount_no_decimals") !== -1) {
            cents = Currency.convert(price * 100, from, to);
          } else if (from === "JOD" || from == "KWD" || from == "BHD") {
            cents = Currency.convert(price / 10, from, to);
          } else {
            cents = Currency.convert(price, from, to);
          }
          var newFormattedAmount = Currency.formatMoney(cents, newFormat);

          jQuery(this).html(newFormattedAmount);
          var parent = jQuery(this).parent(".sas-price");
          if (parent.data("showCurrency")) {
            jQuery(this).append(
              jQuery("<span></span>", { class: "currency_code" }).html(to)
            );
          }

          // We record the new currency locally.
          jQuery(this).attr("data-currency", to);
        }
      });
    },
  };
  SW.onReady = {
    init: function () {
      SW.header.init();
      SW.megamenu.init();
      SW.slideshow.init();
      SW.page.init();
      SW.collection.init();
      SW.footer.init();
      SW.verticleScroll.init();
      SW.productMediaManager.init();
      SW.currency.convertCurrency();
      //       setTimeout( function(){
      //         window.acp_magento_options.isp_add_to_cart_callback = function( product_id, form_id ) {
      //           SW.collection.refreshMiniCart();
      //           window.onAddToCartFinish( product_id );
      //         }
      //       }, 2000 );
    },
  };
  SW.onLoad = {
    init: function () {
      SW.currency.getLocale();
    },
  };
  $(document).ready(function () {
    SW.onReady.init();
    window.onpageshow = function (event) {
      if (event.persisted) {
        //         window.location.reload();
        $(".cartloading").hide();
        $("#resultLoading").hide();
      }
    };
  });
  $(window).load(function () {
    SW.onLoad.init();
  });
})(jQuery);
